import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Meter from "../../components/Meter";
import { showSuccessMessage, updateUserMeters } from "../../redux/action";
import { Button } from "primereact/button";
import { Badge } from "primereact/badge";
import "./style.scss";
import CreateMeter from "../../components/CreateMeter";
import NoRecordsFound from "../../components/NoRecordsFound";
import { deleteMeter } from "../../services";
import * as services from "../../services";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const Profile = (props) => {
  const { meters } = useSelector((state) => state.redux.userInfo);
  const [requests, setRequests] = useState([]);
  const [addMeter, setAddMeter] = useState(false);
  const dispatch = useDispatch();

  const deleteMeterHandler = (id) => {
    deleteMeter(id).then((response) => {
      const myMeters = meters.filter((ele) => ele.id !== id);
      dispatch(updateUserMeters(myMeters));
    });
  };

  const loadMyRequests = () => {
    services.getMyRequests().then((response) => {
      setRequests(response.data);
    });
  };

  useEffect(() => {
    loadMyRequests();
  }, []);

  const pauseRequest = (requestId) => {
    services.pauseRequest(requestId).then((response) => {
      dispatch(showSuccessMessage("request paused successfully"));
      setTimeout(() => {
        dispatch(showSuccessMessage(""));
      }, 500);
      loadMyRequests();
    });
  };

  const resumeRequest = (requestId) => {
    services.resumeRequest(requestId).then((response) => {
      dispatch(showSuccessMessage("request resumed successfully"));
      setTimeout(() => {
        dispatch(showSuccessMessage(""));
      }, 500);
      loadMyRequests();
    });
  };

  const getStatus = (status) => {
    switch (status) {
      case "pending":
        return <Badge value="Pending" severity="warning"></Badge>;
      case "completed":
        return <Badge value="Completed" severity="success"></Badge>;
      case "running":
        return <Badge value="Running" severity="info"></Badge>;
      case "paused":
        return <Badge value="Paused" severity="danger"></Badge>;
      default:
        return <Badge value="Pending" severity="warning"></Badge>;
    }
  };

  return (
    <div className="row profile">
      {addMeter && <CreateMeter closeAdd={() => setAddMeter(false)} />}
      <div className="col-12">
        <h3 className="font-bold">Meters</h3>
        <div className="row justify-content-end add-meter">
          <Button
            onClick={() => setAddMeter(true)}
            icon="pi pi-plus"
            iconPos="left"
            label="Add New Meter"
          />
        </div>
        <div className="meters my-4">
          {meters.length ? (
            meters.map((meter, index) => (
              <Meter
                meter={meter}
                deleteMeter={() => deleteMeterHandler(meter.id)}
                key={index}
              />
            ))
          ) : (
            <NoRecordsFound message={"No meters Found"} />
          )}
        </div>
      </div>

      <div className="col-12">
        <h3 className="font-bold">Settlements</h3>
        <DataTable
          className="my-4 font-sm"
          paginator
          rows={7}
          value={requests}
          responsiveLayout="scroll"
        >
          <Column field="energy" header="Energy"></Column>
          <Column
            field="price"
            header="Price"
            body={(rowData) => `${rowData.minPrice} - ${rowData.maxPrice}`}
          ></Column>
          <Column
            field="status"
            header="Status"
            body={(rowData) => getStatus(rowData.status)}
          ></Column>

          <Column field="meter.label" header="Meter Label"></Column>
          <Column field="meter.number" header="Meter Number"></Column>
          <Column
            field="action"
            header=""
            body={(rowData) => {
              if (rowData.isApproved) {
                return (
                  <Button
                    label="pause"
                    onClick={() => pauseRequest(rowData.id)}
                    className=" p-button-danger w-0 h-0 px-2 font-sm py-1"
                    aria-label="Pause"
                  />
                );
              }
              if (rowData.isPaused) {
                return (
                  <Button
                    label="play"
                    onClick={() => resumeRequest(rowData.id)}
                    className="p-button-success w-0 h-0 px-2 font-sm py-1"
                    aria-label="Play"
                  />
                );
              }
            }}
          ></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default Profile;
